export default __webpack_public_path__ + "static/home-page-3-d51aab43b14a25caad5250381ceea08c.png";